import LoginCard from '../components/auth/LoginCard'
import Vacancies from '../pages/Vacancies'
import VacancyPage from '../pages/VacancyPage'
import AddVacancyForm from '../pages/AddVacancyForm'
import AddVacancyFromText from '../pages/AddVacancyFromText'
import CandidatePage from '../pages/CandidatePage'
import Questions from '../pages/Questions'
import QuestionPage from '../pages/QuestionPage'

export const publicRoutes = [{ path: '/login', component: LoginCard }]

export const protectedRoutes = [
	{ path: '/vacancies', component: Vacancies },
	{ path: '/vacancies/:id', component: VacancyPage },
	{ path: '/vacancies/:id/candidate/:candidateId', component: CandidatePage },
	{ path: '/add', component: AddVacancyForm },
	{ path: '/add-from-text', component: AddVacancyFromText },
	{ path: '/questions', component: Questions },
	{ path: '/questions/:id', component: QuestionPage },
]
